<template lang="jade">
  div.Input(":tooltip"="fdata.tip || false"
            v-bind:class="{'Input--filled': formInput }"
            ":skin"="skins.inputs")
    input.Input__field.Input__field--password(type="password"
                                              ":disabled"="!fdata.editable"
                                              ":class"="fdata.class"
                                              @keydown="mask"
                                              ":placeholder"="fdata.placeholder"
                                              ":required"="required"
                                              ":name"="fdata.field"
                                              @focus="attempts++"
                                              @blur="validate"
                                              v-bind:class="{ 'Input__field--invalid': error }"
                                              autocomplete="off"
                                              v-model="formInput")
    label.Input__label
      span.Input__label-content
        i.fa.fa-key(style="margin-right: 10px")
        {{ fdata.label }}
    div.Error(v-if="errors" class="animated" transition="fade") 
      p.Error__msg {{ errors }}        
</template>

<script>
  import _ from 'lodash'
  import inputs from '../_shared/traits'

  export default {
    mixins: [inputs],
    data () {
      return {
        formInput: '',
        keymap: ['Delete', 'Backspace', 'Enter', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce: x => {
          let mask = _.filter(x.validation, xs => xs.rule.split(':')[0] === 'mask')
          let validation = _.filter(x.validation, xs => xs.rule.split(':')[0] !== 'mask')
          return Object.assign({}, x, {mask, validation})
        },
        required: true
      },
      paste: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      mask (e) {
        let key = e.key
        if (this.fdata.mask.length === 0 || _.includes(this.keymap, key)) return true
        if (e.ctrlKey || e.metaKey) return true
        let pattern = this.pattern(this.fdata.mask[0].rule.split(':')[1])
        let regex = new RegExp(pattern)
        if (!regex.test(key)) {
          e.preventDefault()
          return false
        }
        return true
      },
      pattern (mask) {
        let flags = mask.replace(/.*\/([gimy]*)$/, '$1')
        return mask.replace(new RegExp('^/(.*?)/' + flags + '$'), '$1')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// password.vue?5e6c2b60